import { render, staticRenderFns } from "./InventoryByProductCategoryReport.vue?vue&type=template&id=087b0a3e&"
import script from "./InventoryByProductCategoryReport.vue?vue&type=script&lang=js&"
export * from "./InventoryByProductCategoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports